export default __webpack_public_path__ + "static/media/creative.4a77cc40.png";